<script setup>
import { ref, computed } from 'vue';
const cookie_consent_data = ref(window.Stash.common.cookie_consent_data);
const fallback_iframe_urls = ref(window.Stash.common.fallback_iframe_urls);

const props = defineProps({
    src: {
        type: String,
        required: true,
    },
    fallbackSrc: {
        type: String,
        required: false,
        default: null,
    },
    requiredConsentCategory: {
        type: String,
        required: true,
    },
});

const fallback = computed(() => props.fallbackSrc || fallback_iframe_urls.value[props.requiredConsentCategory]);
</script>

<template>
    <iframe
        v-if="cookie_consent_data?.consent[requiredConsentCategory] || src === fallbackSrc"
        :src="src"
        frameborder="0"
    />
    <iframe
        v-else
        :src="fallback"
        :data-src="src"
        :data-jix-consent="requiredConsentCategory"
        frameborder="0"
    />
</template>
